import { getContextIdAndProductTypeIdOfBasketItem } from '@/model/basket/getContextIdAndProductTypeIdOfBasketItem';
import { selectBasketItems } from '@/redux/basket/getters/selectBasketItems';
import { StoreState } from '@/redux/types';
import { getDiscountsSupported } from './getDiscountsSupported';

export const getBasketItemsSupportingDiscountCount = (state: StoreState) =>
  selectBasketItems(state).reduce((total, basketItem) => {
    const [contextId, productTypeId] = getContextIdAndProductTypeIdOfBasketItem(basketItem);
    if (contextId && productTypeId) {
      if (getDiscountsSupported(state, contextId, productTypeId)) {
        return total + basketItem.quantity;
      }
    }

    return total;
  }, 0);
